import { IconButton, Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';
import { vyPalette } from '../../../../../../assets/themes/vyPalette.ts';

type ContractPdfViewerToolbarProps = {
  onDownload: () => void;
  onOpenInNewTab: () => void;
};

export const ContractPdfViewerToolbar: React.FC<ContractPdfViewerToolbarProps> = ({
  onDownload,
  onOpenInNewTab,
}) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
        justifyContent: "flex-end",
        backgroundColor: 'common.white',
        borderBottom: `1px solid ${vyPalette.divider}`,
        paddingLeft: 2,
        paddingRight: 2,
        paddingTop: 1,
        paddingBottom: 1
      }}>
      <IconButton
        size="small"
        onClick={onDownload}
        data-vy="contract-pdf-toolbar-download"
        aria-label="Download PDF"
      >
        <VyIcon icon="Download" width="24" height="24" viewBox="0 0 24 24" />
      </IconButton>
      <IconButton
        size="small"
        onClick={onOpenInNewTab}
        data-vy="contract-pdf-toolbar-open-new-tab"
        aria-label="Open in new tab"
      >
        <VyIcon icon="OpenNew" height="24" width="24" viewBox="-1 -1 22 22"/>
      </IconButton>
    </Stack>
  );
};
